export const environment = {
  production: true,
  apiServerBaseUrl: '/oauth',
  storageBaseUrl: 'https://assets.adu-me.com',
  analyticsId: 'UA-127152616-2',
  analyticsIdGa4: 'G-NK3C0X15WK',
  smartInTelephoneNumber: '0120-467-672',
  /* WebAPIに関連する設定 */
  webapi: {
    sessionHeaderKey: 'X-CLTFT-Session',
    tokenHeaderKey: 'X-CLTFT-Token',
    useCookieHeaderKey: 'X-Use-Cookie',
    useCookie: true
  }
};
